module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [_c('div', {
    staticClass: "do-table__filters"
  }, [_c('div', {
    staticClass: "do-table__filters__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": "Personer",
      "tags": _vm.personNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleName,
      "clear": function($event) {
        _vm.selectedNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": "Grupper",
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleTag,
      "clear": function($event) {
        _vm.selectedTags = []
      }
    }
  }), _vm._v(" "), (_vm.employmentTitles.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": "Ansættelser",
      "tags": _vm.employmentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": function($event) {
        _vm.selectedEmploymentTitles = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.organisations.length > 1) ? _c('DoFiltersFilter', {
    attrs: {
      "title": "Organisationer",
      "tags": _vm.organisations,
      "selectedTags": _vm.selectedOrganisations,
      "numberOfSelectedTagsToShow": 1
    },
    on: {
      "select": _vm.selectedOrganisation,
      "clear": function($event) {
        _vm.selectedOrganisations = []
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "do-table__filters__add__explainer-text"
  }, [_vm._v("Viser " + _vm._s(_vm.filteredUsers.length) + " af " + _vm._s(_vm.users.length) + " brugere")])], 1), _vm._v(" "), _c('div', {
    staticClass: "do-table__filters__add"
  }, [_c('DoEmploymentDropdown', {
    attrs: {
      "employmentTypes": _vm.employmentTemplates,
      "selectedEmploymentIds": _vm.selectedEmploymentIds
    },
    on: {
      "onTemplateCreated": _vm.onTemplateCreated,
      "onTemplateUpdated": _vm.onTemplateUpdated,
      "onTemplateDeleted": _vm.onTemplateDeleted,
      "select": _vm.onTemplateSelected
    }
  }), _vm._v(" "), (_vm.isSubmitting) ? _c('div', {
    staticClass: "do-spinner"
  }) : _c('span', [_vm._v("Valgt " + _vm._s(_vm.selectedEmploymentIds.length) + " " + _vm._s(_vm.selectedEmploymentIds.length === 1 ? 'ansættelse' : 'ansættelser'))])], 1)]), _vm._v(" "), _c('SalarySettingsUsersTable', {
    attrs: {
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive,
      "filteredUsers": _vm.filteredUsers,
      "isImportOfEmployments": true,
      "employmentTemplates": _vm.employmentTemplates,
      "selectedEmploymentIds": _vm.selectedEmploymentIds
    },
    on: {
      "toggleEmployment": _vm.toggleEmployment,
      "toggleAllEmployments": _vm.toggleAllEmployments,
      "editEmployment": function($event) {
        return _vm.$emit('editEmployment', $event)
      },
      "setTheEditUser": function($event) {
        return _vm.$emit('setTheEditUser', $event)
      }
    }
  })]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salary-rules__rule-container"
  }, [_c('p', [_vm._v("\n      Med ansættelsesskabeloner kan du sætte standardregler for vikarløn – fx hvilken ansættelse, lønkode og evt. omkostningssted, vikartimer skal udbetales på.\n      Skabeloner skal tilføjes til både fast personale (fx Lærer, Pædagog) og timelønnede vikarer (fx Lærervikar, Pædagogvikar) for at kunne bruges i opsætningen.\n      Du kan altid rette i vikarlønsforslag i efterbehandlingen.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bbe5ff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpus.vue
// module id = 1598
// module chunks = 1